export const PRODUCT_TREE_CONSTRAINTS = {
    name: { maxLength: 30, label: 'Category name' },
    description: { maxLength: 256, label: 'Description' },
};
//# sourceMappingURL=constraints.js.map